export function scrollToSection(id: string) {
  const element = document.getElementById(id)
  element?.scrollIntoView({ behavior: "smooth", block: "start" })
}
